import React from 'react';
import { Tabs, TabsList, TabsTrigger, TabsContent } from '../ui/tabs';

export default function OpsDetailTabs({ value, onChange, tabs, children }) {
  return <Tabs value={value} onValueChange={onChange} className="space-y-6">
    <TabsList aria-label="Detail sections" className="w-full justify-start overflow-x-auto">
      {tabs.map(tab => <TabsTrigger key={tab.id} value={tab.id}>{tab.label}</TabsTrigger>)}
    </TabsList>
    {tabs.map(tab => <TabsContent key={tab.id} value={tab.id}>
      {children(tab.id)}
    </TabsContent>)}
  </Tabs>;
}
